import { isArray, isString } from './isDefined';

const getErrorDetail = error => {
  const fallbackMessage = 'Something went wrong';
  const errors = error?.response?.data?.errors;

  if (isArray(errors) && errors.length > 0) {
    const details = errors.reduce((arr, item) => {
      const detail = item?.detail;
      const title = item?.title;

      if (isString(detail) && detail.trim().length > 0) {
        return [...arr, detail.trim()];
      }

      if (isString(title) && title.trim().length > 0) {
        return [...arr, title.trim()];
      }

      return arr;
    }, []);

    if (details.length > 0) {
      return details.join(' | ');
    }

    return fallbackMessage;
  }

  const rawError =
    error?.response?.data !== undefined ? error.response.data : error;

  if (isString(rawError) && rawError.trim().length === 0) {
    return fallbackMessage;
  }

  const stringifiedError = safeStringify(rawError);

  if (
    isString(stringifiedError) &&
    stringifiedError.trim().length > 0 &&
    !['{}', '[]', 'null', '""'].includes(stringifiedError.trim())
  ) {
    return stringifiedError;
  }

  return fallbackMessage;
};

export default getErrorDetail;

const safeStringify = value => {
  try {
    return JSON.stringify(value);
  } catch {
    return null;
  }
};
